import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Container,
  DropdownToggle,
  DropdownMenu, DropdownItem, UncontrolledDropdown
} from "reactstrap";
import MetaTags from "react-meta-tags";

//Import Breadcrumb
import Breadcrumbs from "../../components/common/Breadcrumb";
import "../../../src/assets/scss/custom/plugins/_datatables.scss";
import { ApiCore } from "../../helpers/api_helper";
import { Loading } from "../../components/common/Loading";
import { AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import CreateForm from "../../components/forms/CreateForm";
import { Endpoints } from "../../utils/Endpoints";
import { StudentFields } from "../../fields/StudentFields";
import SearchMarks from "./search";
import BulkUpload from "./upload";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { can } from "../../utils/Helpers";
import { useHistory } from "react-router-dom";
import { SyncFields } from "../../fields/SyncFields";
import StudentCard from "./StudentCard";

const Students = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [syncing, setSyncing] = useState<boolean>(false);
  const [students, setStudents] = useState<any[]>([]);
  const [showStudentDialog, setShowStudentDialog] = useState<boolean>(false);
  const [showSyncDialog, setShowSyncDialog] = useState<boolean>(false);
  const [showStudentBulkDialog, setShowStudentBulkDialog] = useState<boolean>(false);
  const history = useHistory();
  const [initialValues, setInitialValues] = useState<any>({
    firstname: "",
    lastname: ""
  });

  const [initialSyncValues, setInitialSyncValues] = useState<any>({
    form: ""
  });

  const handleOption = (item: any, type: string) => {
    if (type == "edit") {
      setInitialValues(item);
      setShowStudentDialog(true);
    } else if (type == "new") {
      setInitialValues({
        firstname: "",
        lastname: ""
      });
      setShowStudentDialog(true);
    } else if (type == "bulk") {
      setShowStudentBulkDialog(true);
    } else if (type == "details") {
      history.push("/students/" + item.id);
    } else if (type == "sync") {
      if (window.confirm("Do you want to sync this data")) {
        setShowSyncDialog(true)
        return;
      }
    }
  }

  const request = new ApiCore();

  const isAdminUser = () => {
    const currentUser = localStorage.getItem("__portal__user__");
    if (!currentUser) {
      return false;
    }
    try {
      const user = JSON.parse(currentUser);
      return (
        !!user.admin ||
        !!user.is_admin ||
        user.role === "admin" ||
        user.role === "superadmin"
      );
    } catch (e) {
      return false;
    }
  };

  const isAdmin = isAdminUser();

  useEffect(() => {
    searchStudents({})
  }, []);

  const handleUpdate = (item: any) => {
    const items = students.map((i: any) => {
      if (i.id === item.id) {
        return { ...i, ...item };
      }

      return i;
    })
    setStudents(items);
  };

  const searchStudents = (values: any) => {
    values.per_page = 1000;
    request
      .get(Endpoints.students, { params: values }, values.excel && values.excel == 1 ? "arraybuffer" : "json").then((response: AxiosResponse) => {
        setStudents(Array.isArray(response.data) ? response.data : []);
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  }

  const handleBulkUpload = (values: any) => {
    const responseType = "arraybuffer";
    toast.promise(request.createFormData(Endpoints.students, values, responseType), {
      pending: "Please wait..",
      success: {
        render({ data }) {
          let message: any = "";
          return message;
        }
      },
      error: {
        render({ data }) {
          return data;
        }
      }
    }).then((response: AxiosResponse) => {
      if (values.file) {
        //Nothing to do here
      } else if (values.excel && values.excel == 1) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], { type: type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `mustard-${+ new Date()}.xlsx`
        link.click()
      }
    });
  }

  const handlePromote = () => {
    const responseType = "arraybuffer";
    toast.promise(request.get(Endpoints.promoteStudents, { params: { promote: 1 } }), {
      pending: "Please wait..",
      success: {
        render({ data }) {
          return data;
        }
      },
      error: {
        render({ data }) {
          return data;
        }
      }
    });
  }

  const handleSync = (values: any) => {
    setShowSyncDialog(false);
    setSyncing(true);
    request
      .get(Endpoints.sync, { params: values }).then((response: AxiosResponse) => {
        setSyncing(false);
      }).catch((error) => {
        setSyncing(false);
        toast.error(error);
      });
    }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Students - Treda</title>
        </MetaTags>

        <Container fluid>
          <Breadcrumbs title="Students" breadcrumbItem="List" />

          <XModal title={"Add a student"}
            width={"lg"}
            open={showStudentDialog}
            toggle={() => setShowStudentDialog(!showStudentDialog)}
            onClose={() => setShowStudentDialog(false)}>

            <CreateForm
              fields={StudentFields}
              initialValues={initialValues}
              submitEndpoint={initialValues.id ? Endpoints.students + "/" + initialValues.id : Endpoints.students}
              submitButtonLabel={initialValues.id ? "Edit Student" : "Add Student"}
              debug={false}
              formData={true}
              handleUpdate={handleUpdate}
              onClose={() => setShowStudentDialog(false)} />

          </XModal>

          <XModal title={"Sync Data"}
            width={"lg"}
            open={showSyncDialog}
            toggle={() => setShowSyncDialog(!showSyncDialog)}
            onClose={() => setShowSyncDialog(false)}>

            <CreateForm
              fields={SyncFields}
              initialValues={initialSyncValues}
              submitEndpoint={Endpoints.sync}
              submitButtonLabel={"Synchronize"}
              debug={false}
              handleUpdate={handleUpdate}
              handleCustomSubmit={handleSync}
              onClose={() => setShowSyncDialog(false)} />

          </XModal>          

          <XModal title={"Upload students"}
            width={"lg"}
            open={showStudentBulkDialog}
            toggle={() => setShowStudentBulkDialog(!showStudentBulkDialog)}
            onClose={() => setShowStudentBulkDialog(false)}>

            <BulkUpload handleSubmit={handleBulkUpload} initialValues={{ autoid: 0 }} />

          </XModal>

          <Row>
            <Col md={12} lg={12} xl={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">
                    Students
                  </CardTitle>

                  {isAdmin && (
                    <UncontrolledDropdown className="mt-4 mt-sm-0">
                      <DropdownToggle tag="a" className="btn btn-light">
                        <i className="fa fa-ellipsis-v"></i>
                      </DropdownToggle>

                      <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem to="#" onClick={() => handleOption(null, "sync")}>
                          Synchronize
                        </DropdownItem>
                        {can("manage", "School::Student") && (
                          <>
                            <DropdownItem to="#" onClick={() => handleOption(null, "new")}>
                              Add student
                            </DropdownItem>
                            <DropdownItem to="#" onClick={() => handleOption(null, "bulk")}>
                              Upload students
                            </DropdownItem>
                            <DropdownItem to="#" onClick={() => handleOption(null, "promote")}>
                              Promote students
                            </DropdownItem>
                          </>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                </CardHeader>
                <CardBody>
                  {syncing && <Loading label="Data synchronization in progress. Please wait.." />}
                  {loading && <Loading label="Loading students. Please wait." />}
                  {!loading && (
                    <>
                      <Row className="mb-2">
                        {isAdmin && (
                          <Col xl="12">
                            <SearchMarks
                              handleSearch={(values: any) => {
                                searchStudents(values);
                              }}
                            />
                          </Col>
                        )}
                        <ToastContainer />
                      </Row>

                      {students.length === 0 ? (
                        <p className="text-muted mb-0">No students found.</p>
                      ) : (
                        <Row>
                          {students.map((student: any) => (
                            <Col md={6} lg={4} key={student.id} className="mb-3">
                              <StudentCard student={student} />
                            </Col>
                          ))}
                        </Row>
                      )}
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>

      </div>
    </React.Fragment>
  );
};

export default Students;